import BaseModel from "./BaseModel";

/**
 * Testimony
 */
export default class Testimony extends BaseModel{
  constructor({
    id,
    title,
    occupation,
    content,
    photo,
    testimony_order,
    created_at,
    updated_at
  }) {
    super();

    this.id = id || null;
    this.title = title || null;
    this.occupation = occupation || null;
    this.content = content || null;
    this.photo = photo || null;
    this.testimony_order = testimony_order || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
  }

  /**
   * Gets Testimony photo
   * @returns {String}
   */
  getPhoto() {
    if (this.photo && this.photo.includes('data:image/jpeg;base64,')) {
      return this.photo;
    }
    return this.photo ? `data:image/jpeg;base64,${this.photo}` : '';
  }

  /**
   * Gets Testimony content shortened
   */
  getShortContent(size = 100) {
    return this.content.trim().substring(0, size) + (this.content.length > size ? '...' : '');
  }
}
